import { useState } from 'react';
import type { TAppModalData } from 'src/types';

export const useAppModal = () => {
    const [modalData, setModalData] = useState<TAppModalData | undefined>();

    const handleCallModal = (nextModal: TAppModalData) => setModalData(nextModal);

    const handleCloseModal = () => setModalData(undefined);

    return { modalData, handleCallModal, handleCloseModal };
};
